var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastermaintenanceWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 20,
    height: 20,
    transform: "translate(20 115)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_53",
    "data-name": "Mask Group 53",
    transform: "translate(-20 -115)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(19.565 114.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M15.652,2.609H5.943a2.609,2.609,0,1,0,0,1.739h9.709a2.609,2.609,0,0,1,0,5.217H12.9a2.609,2.609,0,0,0-4.9,0H5.217a4.348,4.348,0,0,0,0,8.7h5.217v2.609l3.478-3.478-3.478-3.478v2.609H5.217a2.609,2.609,0,0,1,0-5.217H8a2.609,2.609,0,0,0,4.895,0h2.755a4.348,4.348,0,1,0,0-8.7ZM3.478,4.348a.87.87,0,1,1,.87-.87A.87.87,0,0,1,3.478,4.348ZM10.435,11.3a.87.87,0,1,1,.87-.87A.87.87,0,0,1,10.435,11.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M17.391,14.782A2.609,2.609,0,1,0,20,17.391,2.609,2.609,0,0,0,17.391,14.782Zm0,3.478a.87.87,0,1,1,.87-.87A.87.87,0,0,1,17.391,18.261Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastermaintenanceWhite);
export default __webpack_public_path__ + "static/media/mastermaintenance-white.7d8ea084005e0abd501e85cca28d1fc5.svg";
export { ForwardRef as ReactComponent };